// extracted by mini-css-extract-plugin
export default {"container":"_lAhhhfj1voaIgBbixDL","wrapper":"LPflzTH2hYcbfxAuyc5L","leftContent":"P21MWYY7FdQrpMAe_jwh","rightContent":"Vp_ifFYi3sQ1p4wqL3in"};